import {Extension} from "./Extension";
import {AsyncSubject, Observable, of} from "rxjs";
import {Log, LogTag} from "../Log";
import * as websocket from 'websocket';

export class AndroidExtension extends Extension {
  client = null;

  constructor() {
    super();
  }

  connect(): Observable<any> {
    const logInfo = Log.getLogInfo("AndroidExtension", "connect", []);
    return new Observable(sub => {
      try {
        Log.d(logInfo, LogTag.PLAYER_SERVICE, "webSocket connect");

        const url = 'ws://localhost:8090';
        //const url = 'ws://192.168.0.113:5555';

        const client = new websocket.w3cwebsocket(url);
        client.onopen = () => {
          Log.d(logInfo, LogTag.PLAYER_SERVICE, "webSocket open");
          this.client = client;
          this.isInstalled = true; //???
          sub.next("connected");
          sub.complete();
        };
        client.onmessage = msg => {
          const message = JSON.parse(msg.data);
          const obs$ = this.messageMap[message.messageId];
          if (obs$ != null) {
            obs$.next(message.result);
            Log.d(logInfo, LogTag.PLAYER_SERVICE, "webSocket message: " + message.result);
            obs$.complete();
            delete this.messageMap[message.messageId];
          }
        }
        client.onerror = err => {
          Log.e(logInfo, LogTag.PLAYER_SERVICE, "webSocket error");
          this.client = null;
        };
      } catch (e) {
        Log.e(logInfo, LogTag.PLAYER_SERVICE, "webSocket exception");
        this.client = null;
        sub.next(null);
        sub.complete();
      }
    })
  }

  call(command, args = null): Observable<any> {
    return this.sendCommand(command, args);
  }

  sendCommand(command, args): Observable<any> {
    const logInfo = Log.getLogInfo("AndroidExtension", "sendCommand", [command, args]);
    Log.d(logInfo, LogTag.WEBSOCKET, "")
    this.lastId++;
    const messageId = this.lastId.toString();
    const message = {source: "signPlayerPwa", messageId: messageId, command: command};
    if (args != null) {
      for (const key in args) {
        message[key] = args[key];
      }
    }
    this.client.send(JSON.stringify(message));
    const obs$ = this.messageMap[messageId] = new AsyncSubject();
    return obs$;
  }

}
